import { Parallax } from "../components";
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate";
import fgInput from "../components/Inputs/formGroupInput.vue";

//sidebar
import SideBar from "../components/SidebarPlugin";
/**
 * You can register global components here
 */

const globalComponents = {
  install(Vue) {
    Vue.component("fg-input", fgInput);
    Vue.component(Parallax.name, Parallax);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);

    Vue.use(SideBar);
  }
};

export default globalComponents;
